import { Communication } from '../../../../../../../services/api-client/contact-api';
import { CommStatus } from '../../../../../../../services/api-client/contact-api.types';
import { CompleteStatus, StandardStatus, SuccessStatus } from '../../../patient-profile-widget.styles';

export const getCommStatus = (comm: Communication) => {
  switch (comm.status) {
    case CommStatus.Scheduled:
      return <CompleteStatus>{comm.statusString}</CompleteStatus>;
    case CommStatus.Confirmed:
      return <SuccessStatus>{comm.statusString}</SuccessStatus>;
    default:
      return <StandardStatus>{comm.statusString}</StandardStatus>;
  }
};
